export const initialState = {
  directoryNames: [],
  directories: [],
};
